export const vert = /*glsl*/ `
precision mediump float;

uniform mat4 projectionMatrix;
uniform mat4 modelViewMatrix;

attribute vec3 position;
attribute vec2 uv;
varying vec2 vUv;

uniform float curveIntensity;

void main(){
  vUv = uv;
  vec3 pos = position;
  pos.y *= smoothstep(.0, .01, pos.y) + .1;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos,1.);
}`;
